const APPLICATION_NAMES = {
  FORMSUI: 'FormsUI',
  LEADFLOWSUI: 'lead-flows-ui'
};
export default APPLICATION_NAMES;